import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@/lib/api/client'
export function ProducerContractPanel() {
  const [open, setOpen] = useState(false)
  const contract = useQuery({
    queryKey: ['live-producer-contract'],
    enabled: open,
    retry: false,
    queryFn: async () =>
      (
        await apiClient.get<Record<string, string | number | boolean>>(
          '/api/v1/worlds/producer-contract'
        )
      ).data,
  })
  return (
    <details className="rounded-xl border p-4" onToggle={(e) => setOpen(e.currentTarget.open)}>
      <summary className="cursor-pointer font-medium">
        Live producer spend contract · read-only
      </summary>
      <p className="mt-3 text-xs text-muted-foreground">
        Authenticated producer attestation. This diagnostic does not enable generation, change
        configuration or approve spend.
      </p>
      {contract.isFetching && <p role="status">Reading current producer contract…</p>}
      {contract.error && (
        <p role="alert">Producer attestation unavailable. Generation must remain held.</p>
      )}
      {contract.data && (
        <dl className="mt-3 space-y-2">
          {Object.entries(contract.data).map(([key, value]) => (
            <div key={key} className="grid gap-1 border-b pb-2 text-xs sm:grid-cols-[180px_1fr]">
              <dt>{key}</dt>
              <dd className="break-all">{String(value)}</dd>
            </div>
          ))}
        </dl>
      )}
    </details>
  )
}
